/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DistributeRewardRequest
 */
export interface DistributeRewardRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof DistributeRewardRequest
     */
    userIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof DistributeRewardRequest
     */
    rewardConfigId: string;
}

export function DistributeRewardRequestFromJSON(json: any): DistributeRewardRequest {
    return DistributeRewardRequestFromJSONTyped(json, false);
}

export function DistributeRewardRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DistributeRewardRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userIds': json['userIds'],
        'rewardConfigId': json['rewardConfigId'],
    };
}

export function DistributeRewardRequestToJSON(value?: DistributeRewardRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userIds': value.userIds,
        'rewardConfigId': value.rewardConfigId,
    };
}


